import { Component, OnInit, Inject } from '@angular/core';
import { Contact } from '../../../../common/models/contact';
import { PersonalDataService } from '../../personalData/personal-data.service';
import { UtilitiesService } from '../../../../common/shared/services/utilities.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-benefit-form',
  templateUrl: './benefit-form.component.html'
})
export class BenefitFormComponent implements OnInit {
  contact: Contact;

  constructor(
    @Inject(MAT_DIALOG_DATA) public input: any,
    private _dialogRef: MatDialogRef<BenefitFormComponent>,
    private _personalDataService: PersonalDataService,
    private utilitiesService: UtilitiesService
  ) { }

  ngOnInit() {
    this.contact = new Contact();
    if (this.input !== null) {
      // Creating new instance/do a deep copy to not sync data between View and Edit.
      this.contact = JSON.parse(JSON.stringify(this.input.contact));
    }
  }

  update() {
    this._personalDataService.updateContact(this.contact).subscribe(
      data => {
        if (this.utilitiesService.getData(data)) {
          this._dialogRef.close('Success');
        } else {
          this._dialogRef.close('Error');
        }
      },
      err => {
        this.utilitiesService.handleErrors(err);
        this._dialogRef.close('Close');
      }
    );
  }
}
